// extracted by mini-css-extract-plugin
module.exports = {"community-page-fix-tab":"FixTab_community-page-fix-tab__0QUyA"};